import { Component } from '@angular/core';
import { getDocumentNumber } from '../../../../@core/common/global';
import { ApiService } from '../../../../@core/service/api.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { CompilationModel } from '../../../../@models/erp/compilation';
import { CompilationTypeData } from '../../../../@models/erp/compilationData';
import { DocumentSelectComponent } from './document-select.component';


@Component({
  selector: 'ngx-document-mover',
  templateUrl: '../document-select/document-select.component.html',
  styleUrls: ['../document-select/document-select.component.scss'],
})
export class DocumentMoverComponent extends DocumentSelectComponent {

  constructor(public api: ApiService, public data: SharedDataService) {
    super(data);
  }

  columns = [
    // { id: 'type', title: 'Document type', search: '' },
    { id: 'code', title: 'Document number', search: '' },
    { id: 'recipient', title: 'Recipient', search: '' },
    { id: 'customerDocumentNumber', title: 'PO Document number', search: '' },
  ]

  getText(col: string, item: CompilationModel) {
    if (!item) return '';
    switch (col) {
      case 'type': return CompilationTypeData.getHeading(item); // return CompilationTypeData.get(item.type).name;
      case 'code': return getDocumentNumber(item);
      case 'recipient': return ((item.recipient || {})['name'] || '');
      default: return item[col];
    }
  }

  preFilter(items: CompilationModel[]) {
    const compilation = this.abstractItem as CompilationModel;
    const parentRegex = new RegExp(`^(${CompilationTypeData.get(compilation.type).parentCode.join('|')})NRK${compilation.issuer === 3 ? 'G' : 'A' }`);
    // this.columns.find(f => f.id === 'code').search
    //   = (this.getText('code', items.find(f =>
    //     f.code === this.compilation.parent
    //   )).match(/([^0-9]+)/) || [null])[0];

    return items.filter(f => parentRegex.test(f.code) && !f.draft);
  }

  onSelect(item, event) {
    this.hide();
    (this.abstractItem as CompilationModel).parent = item.code;
    this.compilationChange.emit(this.abstractItem as CompilationModel);
  }

}

